import { connect } from "react-redux"

import {
    feedModerate,
    feedSetEditMode,
    feedToggleRejectionReasonModal
} from "../../../../actions/feed-actions"
import ViewFeedFormActionButtonsWidget from "./ViewFeedFormActionButtonsWidget"

const mapStateToProps = ({ presentation: { feed }, authentication }) => ({
    canEdit: true,
    canDelete: authentication.permissions.indexOf("w_feed") !== -1,
    showDelete: false,
    activeId: feed.activeId,
    isDeleting: feed.isDeletingItem,
    isRejectReasonModalOpen: feed.isRejectReasonModalOpen,
    isSaving: feed.isSavingItem,
    moderationStatus: feed.workingModel.approved,
    suggestedModerationStatus: feed.workingModel.approval_suggestion
})

const mapDispatchToProps = dispatch => ({
    onEdit: () => dispatch(feedSetEditMode(true)),
    approve: () => dispatch(feedModerate(true)),
    reject: () => dispatch(feedToggleRejectionReasonModal()),
    unmoderate: () => dispatch(feedModerate(null))
})

export default connect(mapStateToProps, mapDispatchToProps)(
    ViewFeedFormActionButtonsWidget
)
